/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Switch, Redirect, Route } from 'react-router-dom';
import { Layout, Spin } from 'antd';

import Header from 'components/Header';
import SideBar from 'components/SideBar';

import PrivateRoute from 'components/PrivateRoute';

import route from 'route';

// IMPORT MODULES
import Home from 'modules/Home/container/Home.container';
import UserControl from 'modules/UserControl/container/UserControl.container';
import Audit from 'modules/Audit/route/AuditNavigation';
import Organization from 'modules/Organization/route/OrganizationNavigation';
import AllBillers from 'modules/AllBillers/route/AllBillersNavigation';
import Gold from 'modules/Gold/route/GoldNavigation';
import Delivery from 'modules/Delivery/route/DeliveryNavigation';
import packageInfo from '../../../package.json';

export class Dashboard extends PureComponent {
  componentDidUpdate(prevProps) {
    if (prevProps.auth0loading !== this.props.auth0loading) {
      this.props.initGetAllToken();
    }
  }

  componentDidMount() {
    const attributes = {
      package_version: packageInfo.version,
      app_name: 'Back Office Biz Central - Innovation',
      current_url: window.location.href,
    };

    this.props.initSplit(['bo_marquee_info'], attributes);
  }

  _getRoutes = () => [
    { path: route.DASHBOARD, component: Home },
    { path: route.HOME, component: Home },
    { path: route.USER_CONTROL, component: UserControl },
    ...Audit(),
    ...Organization(),
    ...AllBillers(),
    ...Gold(),
    ...Delivery(),
  ];

  _redirectToHome = () => <Redirect to={route.DASHBOARD} />;

  _confirmNavigate = (e, callback) => {
    if (this.props.interaction) {
      if (e && e.preventDefault) {
        if (!confirm('Changes you made may not be saved.')) {
          e.preventDefault();
        } else {
          this.props.removeNavConfirm();
        }
      } else if (confirm('Changes you made may not be saved.')) {
        this.props.removeNavConfirm();
        callback();
      }
    } else if (callback) callback();
  };

  _renderLoading() {
    return (
      <div
        style={{
          position: 'absolute',
          top: '0px',
          bottom: '0px',
          left: '0px',
          right: '0px',
          textAlign: 'center',
          backgroundColor: 'white',
          opacity: '0.5',
        }}
      >
        <Spin size="large" style={{ position: 'relative', top: '50%' }} />
      </div>
    );
  }

  _renderContent(intl) {
    return (
      <Layout style={{ flexDirection: 'row' }}>
        <SideBar
          location={location}
          intl={intl}
          token={this.props.token}
          confirmNavigate={this._confirmNavigate}
        />
        <Layout.Content>
          <Switch>
            {this._getRoutes().map(item => (
              <PrivateRoute
                exact
                key={item.path}
                path={item.path}
                composedComponent={item.component}
              />
            ))}

            <Route render={this._redirectToHome} />
          </Switch>
        </Layout.Content>
      </Layout>
    );
  }

  render() {
    const {
      intl,
      me,
      auth0loading,
      getAllTokenLoading,
      marqueeSplit,
    } = this.props;
    const isLoading = auth0loading || getAllTokenLoading;

    const info =
      marqueeSplit.treatment === 'on'
        ? JSON.parse(marqueeSplit.config).message
        : '';

    return (
      <Layout style={{ minHeight: '100%' }}>
        <Header
          intl={intl}
          me={me}
          confirmNavigate={this._confirmNavigate}
          auth0logout={this.props.auth0logout}
          info={info}
        />
        {isLoading ? this._renderLoading() : this._renderContent(intl)}
      </Layout>
    );
  }
}

Dashboard.propTypes = {
  intl: PropTypes.object.isRequired,
  interaction: PropTypes.bool.isRequired,
  removeNavConfirm: PropTypes.func.isRequired,
  auth0loading: PropTypes.bool.isRequired,
  initGetAllToken: PropTypes.func.isRequired,
  initSplit: PropTypes.func,
  me: PropTypes.object,
  token: PropTypes.object,
  getAllTokenLoading: PropTypes.bool,
  auth0logout: PropTypes.func.isRequired,
  marqueeSplit: PropTypes.any,
};

export default Dashboard;
